import { Struct } from "@yume-chan/struct";

export const BasicControlMessage = new Struct().uint8("type");
